<template>
  <div class="modal-card" style="width: auto">
    <section class="modal-card-body">
      <div class="title is-5">{{ settings.title }}</div>
      <div class="content has-text-7">{{ settings.warning }}</div>
      <div class="buttons">
        <button class="button" @click="$parent.close()">
          {{ settings.cancel }}
        </button>
        <button
          class="button"
          :class="settings.confirmButtonColor"
          @click="confirm"
        >
          {{ settings.confirm }}
        </button>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  props: {
    settings: {
      type: Object,
      default: () => {
        return {
          confirm: "Подтвердить",
          cancel: "Отменить",
          warning: "",
          title: "Подтвердите действие",
          confirmButtonColor: "is-primary"
        };
      }
    }
  },
  methods: {
    confirm() {
      this.$emit("confirm");
    }
  }
};
</script>
